import { connect } from 'react-redux'
import AssetSearchResultView  from '../../search/asset/AssetSearchResultView.jsx'
import { browserHistory } from 'react-router';
import {fetchAssetDetail} from 'src/legacy/redux/actions/search.jsx'
import {recordSearchClick} from 'src/legacy/redux/actions/hub.jsx'

const mapStateToProps = (state, ownProps) => {
  return {
    query: state.legacyRootReducer.search.assets.query,
    assetDetail: state.legacyRootReducer.search.assetDetails.item
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAssetDetail:(asset) => {
      return dispatch(fetchAssetDetail(asset));
    },
    recordSearchClick:(id, type) => {
      return dispatch(recordSearchClick(id,type));
    },
  }
}

const AssetSearchResultContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetSearchResultView)

export default AssetSearchResultContainer